import React, { lazy, Suspense } from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
// Imported from the module, not the `features/auth` barrel: the barrel re-exports
// a `.jsx` file, which jest's transform does not cover.
import { ProtectedRoute } from '../auth/components/ProtectedRoute';
import { RequireActiveAccount } from '../../router/guards';
import { featureFlags } from '../../config/featureFlags';
// The skeleton by its component path: it is in the initial bundle, like this file.
import { PageSkeleton } from './components/skeletons/PageSkeleton/PageSkeleton';
import { integrationsSkeletonKind } from './components/skeletons/integrationsSkeletonKind';
import { INTEGRATIONS_ROUTE_SEGMENT, TOOLS_SEGMENT } from './constants';

// Page modules, not the feature barrel: importing this file from AppRouter must not pull the
// feature into the main bundle.
const IntegrationsLayout = lazy(() =>
  import('./pages/IntegrationsLayout/IntegrationsLayout').then((m) => ({
    default: m.IntegrationsLayout,
  })),
);
const ProvidersPage = lazy(() =>
  import('./pages/ProvidersPage/ProvidersPage').then((m) => ({ default: m.ProvidersPage })),
);
const SkillToolsPage = lazy(() =>
  import('./pages/SkillToolsPage/SkillToolsPage').then((m) => ({ default: m.SkillToolsPage })),
);

/**
 * Behind REACT_APP_FEATURE_INTEGRATIONS while it is a draft on mock connections. The
 * permission is checked by the layout and not here, because whoever lacks it must read which
 * roles can see Integrations, which `ProtectedRoute`'s denied screen does not say.
 */
const IntegrationsGate: React.FC = () => {
  const { pathname } = useLocation();
  // Off: nothing of the section draws, not even its loading shape.
  if (!featureFlags.integrations) return <Navigate to=".." replace />;
  return (
    <ProtectedRoute>
      <RequireActiveAccount>
        <Suspense
          fallback={<PageSkeleton kind={integrationsSkeletonKind(pathname) ?? 'providers'} />}
        >
          <IntegrationsLayout />
        </Suspense>
      </RequireActiveAccount>
    </ProtectedRoute>
  );
};

/**
 * Route subtree of Integrations, mounted by AppRouter under the account
 * (`accounts/:accountId/integrations`). Each tab is a route, so a shared link opens on it.
 */
export const integrationsRoutes = (
  <Route path={INTEGRATIONS_ROUTE_SEGMENT} element={<IntegrationsGate />}>
    <Route index element={<ProvidersPage />} />
    <Route path={TOOLS_SEGMENT} element={<SkillToolsPage />} />
  </Route>
);
